import { withNamespace } from '@ux/namespace-component';
import { FormElement } from '@ux/form-element';

/**
 * Interface for creating checkbox elements. Note: this code is also used by React Native to set the type
 * of the Form Element component.
 *
 * @displayName Checkbox
 * @class Checkbox
 * @public
 */
export class Checkbox extends FormElement {
  constructor(...args) {
    super(...args);

    this.type = 'checkbox';
  }
}

export default withNamespace(Checkbox);
